export default __webpack_public_path__ + "assets/schick_banner_1280x120-914cfce6e9682b9b15336d44e04600d8.jpg";